import {algoliasearch} from 'algoliasearch';
import {CLAVEAPP, CLAVEESCRITURA} from "../Constantes";

export const borrarRegistro = async ({nombreIndex, id}) => {


//
    const client = algoliasearch(CLAVEAPP, CLAVEESCRITURA);

    return client.deleteObject(
        {
            indexName: nombreIndex,
            objectID: id
        }
    );


}